<template>
    <div>
        <h4 class="mt-2 d-flex items-center titulo"><i class="mr-2 glyphicon glyphicon-user"></i> Dados de acesso</h4>
        <hr class="mt-0" />
        <b-row>
            <b-col md="6">
                <b-form-group label="E-mail" label-for="email" class="required">
                    <b-form-input
                        id="email"
                        name="email"
                        maxlength="60"
                        v-model="data.Usuario.email"
                        v-validate="'required|email'"
                        :class="[{ error: errors.first('email') }]"
                    />
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group label="Senha" label-for="senha" class="required">
                    <b-form-input
                        id="senha"
                        name="senha"
                        type="password"
                        v-model="data.Usuario.senha"
                        v-validate="'required|senha'"
                        :class="[{ error: errors.first('senha') }]"
                        @change="data.Usuario.senha = String(data.Usuario.senha).trim()"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="12">
                <validacao-senha :senha="data.Usuario.senha" />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import ValidacaoSenha from '@/shared/components/ui/ValidacaoSenha'
export default {
    inject: ['$validator'],
    components: {
        ValidacaoSenha
    },
    props: {
        data: {
            default: {}
        }
    }
}
</script>
<style scoped>
.titulo {
    font-size: 20px;
}
</style>
